import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {
  notifSub = new BehaviorSubject<any>([])

  constructor(private http : HttpClient) { }
  getUserNotif() : Observable<any> {
    return this.http.get("/api/notification/v1/get/notifications/user")
  }
  readNotif(notif :any) :Observable<any>{
    return this.http.post("/api/notification/v1/set/user/notifications/state" , notif)
  }
  getNotif(id :any) : Observable<any>{
    return this.http.get("/api/notification/v1/get/notification/"+id)
  }
}
